﻿import {useCallback} from "react";
import {logOff, permitsLogErrorToServer} from "../functions";
import {PublicRoutes} from "../routes";
import {useNavigate} from "react-router";

export function useLogout(): () => Promise<void> {
	const navigate = useNavigate();
	return useCallback(async function (): Promise<void> {
		try {
			await logOff();
			navigate(PublicRoutes.home);

		} catch (error) {
			permitsLogErrorToServer(error);
		}
	}, [navigate]);
}
